import EventObject from "../../../modules/tracking/EventObject";

export default function(onclick) {
    const container = document.createElement('div');
    container.classList.add('live-chat-card__btn-container');

    // const whatsAppLink = document.createElement('a');
    // whatsAppLink.classList.add('live-chat-card__whatsapp');
    // whatsAppLink.setAttribute('target', '_blank');
    // whatsAppLink.setAttribute('href', 'https://wa.me/442476851458');

    // const whatsAppImage = document.createElement('img');
    // whatsAppImage.classList.add('live-chat-card__whatsapp-img');
    // whatsAppImage.src = '/images/live-chat/whatsapp.svg';
    // whatsAppImage.addEventListener('click', function() {
    //     new EventObject('Live Chat', 'WhatsApp', 'Opened').dispatch();
    // })
    // whatsAppLink.append(whatsAppImage);

    // container.appendChild(whatsAppLink);

    const chatButton = document.createElement('button');
    chatButton.classList.add('btn');
    chatButton.classList.add('btn-primary');
    chatButton.classList.add('btn--primary');
    chatButton.classList.add('btn--light-font');
    chatButton.classList.add('btn--small-font');
    chatButton.classList.add('btn--drop-shadow');
    // chatButton.classList.add('btn--min-width');
    // chatButton.classList.add('live-chat-card__button');
    chatButton.innerHTML = 'Chat now<div class="loading live-chat-card__loading"><img src="/images/shared/Robins-And-Day-Loader.svg" alt="Starting Chat"></div>';
    chatButton.addEventListener('click', onclick);

    container.appendChild(chatButton);

    return container;
}


// WEBPACK FOOTER //
// ./resources/assets/js/live-chat/modules/elements/create-step-1-content.js